export default "__VITE_ASSET__CnsMqtap__"